import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionType, ImageSize } from '@com-delta-idp/mnx-ui-kit';
import { Card } from './models/card.interfaces';

@Component({
  selector: 'idp-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent {
  @Input() contents: Card = {} as Card;
  @Output() notify: EventEmitter<void> = new EventEmitter();

  notifyParent() {
    this.notify.emit();
  }

  redirect(link: string) {
    window.open(link, '_blank');
  }

  getClassesForLinks(size: ImageSize, actionType: ActionType): string {
    let className = '';
    const baseClass = 'card-small__links--';

    if (size === 'small') {
      className = actionType === 'text' ? `${baseClass}text` : className;
      className = actionType === 'caret' ? `${baseClass}caret` : className;
    }

    return className;
  }

  getImageClass(): string {
    return this.contents.image2 && this.contents.image2.show ? '1' : '';
  }
}
